import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import fetchMerchandiseById from 'actions/merchandise/fetchMerchandiseById'

type ReturnType = [
  App.MerchandiseOffer | undefined,
  boolean,
  { status: number, message: string } | any | undefined,
]

interface Options {
  disabled?: boolean
  prioritisedVariantIds?: Array<string>
}

function useMerchandiseOffer(id: string, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()
  const merchandise = useAppSelector(state => state.merchandise.merchandise[id])
  const fetching = useAppSelector(state => state.merchandise.fetchingMerchandise[id])
  const error = useAppSelector(state => state.merchandise.merchandiseErrors[id])

  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseById(id, options.prioritisedVariantIds))
    }
  }, [dispatch, id, options.disabled, options.prioritisedVariantIds])

  return [merchandise, !!fetching, error]
}

export default useMerchandiseOffer
